import _ from 'lodash';

let initialized = false;
const listeners = [];

const getStatus = () => {
  const vw = window.innerWidth;
  const section = matchMedia('(min-width: 1600px)').matches ? 'xxl'
      : matchMedia('(min-width: 1360px)').matches ? 'xl'
      : matchMedia('(min-width: 1024px)').matches ? 'lg'
        : matchMedia('(min-width: 768px)').matches ? 'md'
          : 'sm';
  return { section, vw };
};

const resized = () => {
  const e = getStatus();
  _.forEach(listeners, listener => listener(e));
};

const init = () => {
  window.addEventListener('resize', resized);
  window.addEventListener('load', resized);
  initialized = true;
};

const addListener = (listener) => {
  if (!initialized) init();
  if (!listener) return;
  listeners.push(listener);
  listener(getStatus());
};

const removeListener = (listener) => {
  if (!initialized) return;
  _.remove(listeners, l => l === listener);
};

export default { addListener, removeListener, resized };
